import PropTypes from "prop-types";

export const miteredSectionInterface = {
  miteredSection: PropTypes.array,
};

export const miteredSegmentInterface = {
  miteredSegment: PropTypes.object,
};

export const waterfallSectionInterface = {
  waterfallSection: PropTypes.array,
};

export const waterfallSegmentInterface = {
  waterfallSegment: PropTypes.object,
};

export const changeValuePopupInterface = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  min: PropTypes.number,
  max: PropTypes.number,
  confirmCallback: PropTypes.func,
  increaseCallback: PropTypes.func,
  decreaseCallback: PropTypes.func,
  inputChangeCallback: PropTypes.func,
  value: PropTypes.number,
  position: PropTypes.object,
};
